import React from 'react';
import styles from './componentCss/Footer.module.css';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

const Footer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavClick = (url) => {
        if (url === '') {
            location.pathname === '/' ? window.scrollTo({ top: 0, behavior: 'smooth' }) : navigate('/');
        } else if (url.startsWith('#')) {
            if (location.pathname === '/') {
                const target = document.querySelector(url);
                if (target) {
                    const yOffset = -90;
                    const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            } else {
                navigate('/');
                setTimeout(() => {
                    const target = document.querySelector(url);
                    if (target) {
                        const yOffset = -90;
                        const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                }, 400);
            }
        } else {
            navigate(`/${url.toLowerCase()}`);
        }
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.content}>
                <div className={styles.left}>
                    <div className={styles.logoRow}>
                        <img
                            src={`${process.env.PUBLIC_URL}/img/Logos/NewLogos/logo 1024.png`}
                            alt="Koboct logo"
                            className={styles.squareLogo}
                        />
                        <div className={styles.slogan}>
                            {t("MainBanner.Title")
                                .split('\n')
                                .map((line, index) => (
                                    <p key={index}>{line}</p>
                                ))}
                        </div>
                    </div>

                    <div className={styles.socials}>
                        <i className="fab fa-facebook-f"></i>
                        <i className="fab fa-twitter"></i>
                        <i className="fab fa-instagram"></i>
                    </div>
                </div>

                <div className={styles.columns}>
                    <div className={styles.column}>
                        <h4>{t("Footer.Liens")}</h4>
                        <ul>
                            <li onClick={() => handleNavClick('')}>{t("Navbar.HomeTab")}</li>
                            <li onClick={() => handleNavClick('#aboutUs')}>{t("AboutUs.Title")}</li>
                            <li onClick={() => handleNavClick('#services')}>{t("OurServices")}</li>
                            <li onClick={() => handleNavClick('#ourProjects')}>{t("Navbar.OurProjects")}</li>
                            <li onClick={() => handleNavClick('Contact')}>{t("Navbar.Contact")}</li>
                        </ul>
                    </div>

                    <div className={styles.column}>
                        <h4>{t("Footer.Legal")}</h4>
                        <ul>
                            <li onClick={() => navigate('/mentions-legales')}>
                                {t("LegalMentions.title")}
                            </li>
                        </ul>
                    </div>

                    <div className={styles.column}>
                        <h4>{t("Footer.Follow")}</h4>
                        <a
                            href="https://www.linkedin.com/company/koboct/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                        >
                            <Linkedin size={18} /> {t("Footer.Linkedin")}
                        </a>
                    </div>
                </div>
            </div>

            <hr className={styles.separator} />

            <div className={styles.bottom}>
                <p>{t("Footer.Mention")}</p>
            </div>
        </footer>
    );
};

export default Footer;
